export class DocumentModel {
    document_id: number
    document_name: string
    document_type: string
    document_data: string
    document_note: string
    created_by: string
    created_on: string

    constructor(
        document_id: number,
        document_name: string,
        document_type: string,
        document_data: string,
        document_note: string,
        created_by: string,
        created_on: string
        
    ) {
        this.document_id= document_id,
        this.document_name= document_name,
        this.document_type= document_type,
        this.document_data= document_data,
        this.document_note= document_note,
        this.created_by= created_by,
        this.created_on= created_on

    }
}